import { render, staticRenderFns } from "./QuestionarioCentroHemodinamica.vue?vue&type=template&id=3453d0ce&scoped=true"
import script from "./QuestionarioCentroHemodinamica.vue?vue&type=script&lang=js"
export * from "./QuestionarioCentroHemodinamica.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioCentroHemodinamica.vue?vue&type=style&index=0&id=3453d0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453d0ce",
  null
  
)

export default component.exports